import { IMenu, TPublicationStatus } from 'src/types/menu.types';
import { IMealtime } from 'src/types/mealtimes.types';
import { Control, FieldValues, UseFormRegister, UseFormWatch } from 'react-hook-form';

export interface IPublishVenue {
  name: string;
  venue_id: string;
  is_trial: boolean;
  priceSchemeName: string;
  publicationDate?: Date;
  publicationStatus?: TPublicationStatus;
}

export interface IPublishDestination {
  name: string;
  channel_id: string;
  /** Selection key; falls back to `channel_id`. Timetable publish sets it to the instance id. */
  destination_id?: string;
  externalSystemName?: string;
  /** Required to publish; unresolvable for a system with zero or several configured addons. */
  extensionInstanceId?: string;
  publicationDate?: Date;
  publicationStatus?: TPublicationStatus;
  venues: IPublishVenue[];
}

export interface IModalProps {
  closeModal?: () => void;
  isOpen: boolean;
  menuId: string;
  menuName: string;
  isTrial?: boolean;
}

export enum PublishSteps {
  Setup = 0,
  Venues = 1,
  Summary = 2,
}

export interface IPublishModalViewProps {
  onBackClick: () => void;
  onContinueClick: () => void;
}

export interface IPublishSetupViewProps {
  control: Control<FieldValues>;
  register: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  menuName: string;
  /** Omit to hide the Mealtimes section (Menu Set publish has no mealtimes). */
  mealtimes?: IMealtime[];
  filteredMealtimes?: IMealtime[];
  publicationData: IPublishDestination[];
  showSchedule: boolean;
  eyebrow?: string;
  getDisabledReason?: (destination: IPublishDestination, selectedIds: string[]) => string | undefined;
}

export interface IPublishViewProps {
  selectedVenueIds: string[];
  onVenuesChange: (venueIds: string[]) => void;
  publicationData: IPublishDestination[];
  selectedChannelIds: string[];
  eyebrow?: string;
}

export interface ISelectedDestination extends IPublishModalViewProps {
  channel: string;
  channel_id: string;
  selected: boolean;
  selectedVenues: string[];
}

export interface IAdditionalMenuViewProps extends IPublishModalViewProps {
  selectableMenus: IMenu[];
  isTrial: boolean;
}
